<template>
  <v-card class="pb-4">
    <div class="px-5 pt-3 pb-2">
      <div style="display: flex; justify-content: space-between">
        <div v-show="false">{{ value }} {{ data }}</div>
        <!-- <div class="headline primary--text mb-6 bold7">
          {{ $t('Member info') }}
          <span v-if="data.admin">
            <v-chip color="red" dark>Admin</v-chip>
          </span>
        </div> -->
        <div style="display: flex">
          <Typography class="mb-6" h2 bold :label="$t('Member info')" />
          <span v-if="data.admin">
            <v-chip color="red" dark>Admin</v-chip>
          </span>
        </div>
        <v-icon style="display: flex; align-items: center" @click="$emit('closemodal')"
          >close</v-icon
        >
      </div>
    </div>
    <MemberInfoEditNoTaxID
      v-if="verification == 'ไม่มี Tax ID' && data"
      @saveedit="editData"
      :isEdit="isEdit"
      :infodata="data"
      @closemodal="$emit('closemodal')"
    ></MemberInfoEditNoTaxID>
    <MemberInfoEditTaxID
      v-else-if="verification == 'มี Tax ID' && data"
      @saveedit="editData"
      :isEdit="isEdit"
      :infodata="data"
      @closemodal="$emit('closemodal')"
    ></MemberInfoEditTaxID>
    <MemberInfoEditRegular
      v-else-if="(verification == 'บุคคลธรรมดา' || verification == 'เกษตรกร') && data"
      @saveedit="editData"
      :infodata="data"
      :isEdit="isEdit"
      @closemodal="$emit('closemodal')"
    ></MemberInfoEditRegular>
    <div v-else>
      <div class="text-xs-center py-5"><h4 style="color: grey">ยังไม่ได้ยืนยันตัวตน</h4></div>
    </div>
    <div class="px-5 mt-3" v-if="data.dbdinfo">
      <v-card
        class="mt-2"
        flat
        style="background-color: #edf5ff !important; border: 1px solid #000090"
        outline
      >
        <div>
          <v-layout row wrap class="px-4">
            <v-flex xs12 class="py-3">
              <Typography h5 bold label="DBD Information" />
            </v-flex>
            <v-flex xs12>
              <div class="dbdlabel">Juristic name</div>
              <div class="dbdinfo">
                {{ juristicNameTH }} ({{ juristicNameEN }})
              </div>
            </v-flex>
            <v-flex xs12 class="pl-0 mt-1">
              <div class="dbdlabel">Standard objectives</div>
              <div class="dbdinfo">
                {{ ObjectiveDescription }}
                <!-- {{ data.dbdinfo.ResultList[0].StandardObjectives[0].ObjectiveDescription }} -->
              </div>
            </v-flex>
            <v-flex xs6 class="pl-0 mt-1">
              <div class="dbdlabel">Juristic ID</div>
              <div class="dbdinfo">
                {{ OrganizationJuristicID }}
                <!-- {{ data.dbdinfo.ResultList[0].JuristicID }} -->
              </div>
            </v-flex>
            <v-flex xs6 class="pl-0 mt-1">
              <div class="dbdlabel">Status</div>
              <div class="dbdinfo">
                {{ JuristicStatus }}
                <!-- {{ data.dbdinfo.ResultList[0].JuristicStatus }} -->
              </div>
            </v-flex>
            <v-flex xs6 class="pl-0 mt-1">
              <div class="dbdlabel">Juristic type</div>
              <div class="dbdinfo">
                {{ JuristicType }}
                <!-- {{ data.dbdinfo.ResultList[0].JuristicType }} -->
              </div>
            </v-flex>
            <v-flex xs6 class="pl-0 mt-1">
              <div class="dbdlabel">Standard ID</div>
              <div class="dbdinfo">
                {{ StandardID }}
                <!-- {{ data.dbdinfo.ResultList[0].StandardID }} -->
              </div>
            </v-flex>
            <v-flex xs6 class="pl-0 mt-1">
              <div class="dbdlabel">Register capital</div>
              <div class="dbdinfo">
                {{ numberWithCommas(RegisterCapital) }}
                <!-- {{ numberWithCommas(data.dbdinfo.ResultList[0].RegisterCapital) }} -->
              </div>
            </v-flex>
            <v-flex xs6 class="pl-0 mt-1">
              <div class="dbdlabel">Paid register capital</div>
              <div class="dbdinfo">
                {{ numberWithCommas(PaidRegisterCapital) }}
                <!-- {{ numberWithCommas(data.dbdinfo.ResultList[0].PaidRegisterCapital) }} -->
              </div>
            </v-flex>
            <v-flex xs12 class="my-3">
              <v-divider></v-divider>
            </v-flex>
            <template>
              <v-flex xs12>
                <div class="font-weight-bold primary--text">Committee Informations</div>
              </v-flex>
              <v-flex xs6 class="mt-1">
                <div class="dbdlabel">First name</div>
                <div class="dbdinfo">
                  {{ isExist(CommitteeInformationsFirstName) }}
                  <!-- {{ isExist(data.dbdinfo.ResultList[0].CommitteeInformations[0].Title) }}
                  {{ isExist(data.dbdinfo.ResultList[0].CommitteeInformations[0].FirstName) }} -->
                </div>
              </v-flex>

              <v-flex xs6 class="mt-1">
                <div class="dbdlabel">Last name</div>
                <div class="dbdinfo">
                  {{ isExist(CommitteeInformationsLastName) }}
                  <!-- {{ isExist(data.dbdinfo.ResultList[0].CommitteeInformations[0].LastName) }} -->
                </div>
              </v-flex>
              <v-flex xs6 class="mt-1">
                <div class="dbdlabel">Sequence</div>
                <div class="dbdinfo">
                  {{ isExist(Sequence) }}
                  <!-- {{ isExist(data.dbdinfo.ResultList[0].CommitteeInformations[0].Sequence) }} -->
                </div>
              </v-flex>
              <v-flex xs6 class="mt-1">
                <div class="dbdlabel">Type</div>
                <div class="dbdinfo">
                  {{ isExist(Type) }}
                  <!-- {{ isExist(data.dbdinfo.ResultList[0].CommitteeInformations[0].Type) }} -->
                </div>
              </v-flex>
              <v-flex xs12 class="my-3">
                <v-divider></v-divider>
              </v-flex>
            </template>
            <template>
              <v-flex xs12>
                <div class="font-weight-bold primary--text">Address Informations</div>
              </v-flex>
              <template v-if="data.dbdinfo.ResultList[0]">
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Address name</div>
                  <div class="dbdinfo">
                    {{ isExist(AddressName) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].AddressName) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Full address</div>
                  <div class="dbdinfo">
                    {{ isExist(FullAddress) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].FullAddress) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Address no</div>
                  <div class="dbdinfo">
                    {{ isExist(AddressNo) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].AddressNo) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Ampur</div>
                  <div class="dbdinfo">
                  {{ isExist(Ampur) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Ampur) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Tumbol</div>
                  <div class="dbdinfo">
                    {{ isExist(Tumbol) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Tumbol) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Road</div>
                  <div class="dbdinfo">
                    {{ isExist(Road) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Road) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Soi</div>
                  <div class="dbdinfo">
                    {{ isExist(Soi) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Soi) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Province</div>
                  <div class="dbdinfo">
                    {{ isExist(Province) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Province) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Village name</div>
                  <div class="dbdinfo">
                    {{ isExist(VillageName) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].VillageName) }} -->
                  </div>
                </v-flex>

                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Email</div>
                  <div class="dbdinfo">
                    {{ isExist(Email) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Email) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Phone</div>
                  <div class="dbdinfo">
                    {{ isExist(Phone) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Phone) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Building</div>
                  <div class="dbdinfo">
                    {{ isExist(Building) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Building) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Floor</div>
                  <div class="dbdinfo">
                    {{ isExist(Floor) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Floor) }} -->
                  </div>
                </v-flex>

                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Moo</div>
                  <div class="dbdinfo">
                    {{ isExist(Moo) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Moo) }} -->
                  </div>
                </v-flex>

                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Room</div>
                  <div class="dbdinfo">
                    {{ isExist(RoomNo) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].RoomNo) }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Sequence</div>
                  <div class="dbdinfo">
                    {{ isExist(AddressSequence) }}
                    <!-- {{ isExist(data.dbdinfo.ResultList[0].AddressInformations[0].Sequence) }} -->
                  </div>
                </v-flex>
              </template>
            </template>
            <template v-if="financial">
              <v-flex xs12 class="my-3">
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12>
                <div class="font-weight-bold primary--text">Financial Informations</div>
              </v-flex>
              <template v-if="data.dbdinfo.ResultList[0]">
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Register Capital</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(RegisterCapital) }}
                    <!-- {{
                      financial.RegisterCapital ? numberWithCommas(financial.RegisterCapital) : '-'
                    }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Account Receivable</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(AccountReceivable) }}
                    <!-- {{
                      financial.AccountReceivable
                        ? numberWithCommas(financial.AccountReceivable)
                        : '-'
                    }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Net Profit</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(NetProfit) }}
                    <!-- {{ financial.NetProfit ? numberWithCommas(financial.NetProfit) : '-' }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Total Asset</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(TotalAsset) }}
                    <!-- {{ financial.TotalAsset ? numberWithCommas(financial.TotalAsset) : '-' }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Total CurrentAsset</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(TotalCurrentAsset) }}
                    <!-- {{
                      financial.TotalCurrentAsset
                        ? numberWithCommas(financial.TotalCurrentAsset)
                        : '-'
                    }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Total Liabilities</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(TotalLiabilities) }}
                    <!-- {{
                      financial.TotalLiabilities
                        ? numberWithCommas(financial.TotalLiabilities)
                        : '-'
                    }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">Total Revenue</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(TotalRevenue) }}
                    <!-- {{ financial.TotalRevenue ? numberWithCommas(financial.TotalRevenue) : '-' }} -->
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-1">
                  <div class="dbdlabel">StatementYear</div>
                  <div class="dbdinfo">
                    {{ numberWithCommas(StatementYear) }}
                    <!-- {{ financial.StatementYear ? financial.StatementYear : '-' }} -->
                  </div>
                </v-flex>
              </template>
            </template>

            <template v-if="
              shareholder && shareholder['cd:OrganizationJuristicShareholderDetail'] && shareholder['cd:OrganizationJuristicShareholderDetail'].length
            ">
              <v-flex xs12 class="my-3">
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12>
                <div class="font-weight-bold primary--text">Shareholder Informations</div>
              </v-flex>
              <v-flex v-for="(item, index) in shareholder['cd:OrganizationJuristicShareholderDetail']" :key="`shear-${index}`" xs12 class="mt-1">
                <div class="dbdinfo">
                  {{ item['cd:JuristicPersonSequence'] }}
                  {{ item['td:JuristicPerson']['cd:Person']['cd:PersonNameTH']['cd:PersonNameTitleTextTH'] }}
                  {{ item['td:JuristicPerson']['cd:Person']['cd:PersonNameTH']['cd:PersonFirstNameTH'] }}
                  {{ item['td:JuristicPerson']['cd:Person']['cd:PersonNameTH']['cd:PersonLastNameTH'] }}
                  <!-- {{ `${item.RowNo} ${item.Title} ${item.HolderName} ${item.Lastname}` }} -->
                </div>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </v-card>
    </div>
    <div class="flex-all-center mt-2" v-if="!isEdit">
      <v-btn
        @click="$emit('closemodal')"
        round
        small
        depressed
        color="primary"
        class="color-lightYellow"
        >ปิด</v-btn
      >
    </div>
    <!-- <div class="px-5 mt-2" v-if="doaeData">
      <v-card
        class="mt-2"
        flat
        style="background-color: #edf5ff !important; border: 1px solid #000090"
        outline
      >
        <div>
          <v-layout row wrap class="px-4">
            <v-flex xs12 class="py-3">
              <div class="font-weight-bold primary--text">DOAE Information</div>
            </v-flex>
            <v-flex xs12>
              <div class="dbdlabel">Juristic name</div>
              <div class="dbdinfo">
                {{ data.dbdinfo.ResultList[0].JuristicName_TH }} ({{
                  data.dbdinfo.ResultList[0].JuristicName_EN
                }})
              </div>
            </v-flex>
            <v-flex xs12 class="pl-0 mt-1">
              <div class="dbdlabel">Standard objectives</div>
              <div class="dbdinfo">
                {{ data.dbdinfo.ResultList[0].StandardObjectives[0].ObjectiveDescription }}
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </div> -->
  </v-card>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import UploadFileButton from '@/components/elements/UploadFileButton.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import UploadProfile from '@/components/elements/UploadProfile.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import MemberInfoEditNoTaxID from './MemberInfoEditNoTaxID.vue'
import MemberInfoEditTaxID from './MemberInfoEditTaxID.vue'
import MemberInfoEditRegular from './MemberInfoEditRegular.vue'
import { mapGetters } from 'vuex'
import Typography from '@/components/elements/Typography.vue'

export default {
  props: ['value', 'inputEdit', 'isEdit'],
  components: {
    Multiselect,
    DropdownMenu,
    UploadFileButton,
    UploadProfile,
    DatePickerWithoutButton,
    MemberInfoEditNoTaxID,
    MemberInfoEditTaxID,
    MemberInfoEditRegular,
    Typography,
  },
  data() {
    return {
      data: null,
      loading: false,
      optionsStatus: ['unconfirmed', 'confirm', 'cancel'],
      financial: null,
      shareholder: null,
      // doaeData: null,
      year: parseInt(moment(new Date()).format('YYYY')) + 542,
      isEdit: false,
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    depamembertype() {
      return this.$store.state.depamembertype
    },
    verification() {
      var membertype = this.$store.state.depamembertype.find(
        (el) => el.typeid == this.inputEdit.membertype_id
      )

      if (membertype) {
        return membertype.verification
      } else {
        return ''
      }
    },
    juristicId() {
      return this.inputEdit &&
        this.inputEdit.dbdinfo &&
        this.inputEdit.dbdinfo.ResultList &&
        this.inputEdit.dbdinfo.ResultList[0] &&
        (this.inputEdit.dbdinfo.ResultList[0].JuristicID || this.inputEdit.dbdinfo.ResultList[0]["cd:OrganizationJuristicID"])
        ? (this.inputEdit.dbdinfo.ResultList[0].JuristicID || this.inputEdit.dbdinfo.ResultList[0]["cd:OrganizationJuristicID"]) 
        : null
    },
    juristicNameTH() {
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.JuristicName_TH || r['cd:OrganizationJuristicNameTH'] || '-';
    },
    juristicNameEN() {
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.JuristicName_EN || r['cd:OrganizationJuristicNameEN'] || '-';
    },
    ObjectiveDescription(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      const oldObjective =
        r.StandardObjectives &&
        r.StandardObjectives[0] &&
        r.StandardObjectives[0].ObjectiveDescription;

      const newObjective =
        r['cd:OrganizationJuristicObjective'] &&
        r['cd:OrganizationJuristicObjective'][0] &&
        r['cd:OrganizationJuristicObjective'][0]['td:JuristicObjectiveTextTH'];

      return oldObjective || newObjective || '-';
    },
    OrganizationJuristicID(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.JuristicID || r['cd:OrganizationJuristicID'] || '-';
    },
    JuristicStatus(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.JuristicStatus || r['cd:OrganizationJuristicStatus'];
    },
    JuristicType(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.JuristicType || r['cd:OrganizationJuristicType'];
    },
    StandardID(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const newStandardID =
        r['cd:OrganizationJuristicObjective'] &&
        r['cd:OrganizationJuristicObjective'][0] &&
        r['cd:OrganizationJuristicObjective'][0]['td:JuristicObjectiveCode'];

      return r.StandardID || newStandardID;
    },
    RegisterCapital(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.RegisterCapital || r['cd:OrganizationJuristicRegisterCapital'];
    },
    PaidRegisterCapital(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      return r.PaidRegisterCapital || r['cd:OrganizationJuristicPaidUpCapital'] || '-';
    },
    CommitteeInformationsFirstName(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      const Title =
        r.CommitteeInformations &&
        r.CommitteeInformations[0] &&
        r.CommitteeInformations[0].Title;

      const FirstName =
        r.CommitteeInformations &&
        r.CommitteeInformations[0] &&
        r.CommitteeInformations[0].FirstName;
      
      const juristicPersonList = r['cd:OrganizationJuristicPersonList'];

      const nameTH =
        juristicPersonList &&
        juristicPersonList[0] &&
        juristicPersonList[0]['td:JuristicPerson'] &&
        juristicPersonList[0]['td:JuristicPerson']['cd:PersonNameTH'];

      const FirstNameTH =
        (nameTH && nameTH['cd:PersonNameTitleTextTH'] || '') +
        (nameTH && nameTH['cd:PersonFirstNameTH'] || '');

      const TitleFirstName = (Title || '') + (FirstName || '');

      return TitleFirstName || FirstNameTH;
    },
    CommitteeInformationsLastName(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const LastName =
        r.CommitteeInformations &&
        r.CommitteeInformations[0] &&
        r.CommitteeInformations[0].LastName;
      
      const juristicPersonList = r['cd:OrganizationJuristicPersonList'];

      const LastNameTH =
        juristicPersonList &&
        juristicPersonList[0] &&
        juristicPersonList[0]['td:JuristicPerson'] &&
        juristicPersonList[0]['td:JuristicPerson']['cd:PersonNameTH'];

      const FullLastNameTH =
        (LastNameTH && LastNameTH['cd:PersonMiddleNameTH'] || '') +
        (LastNameTH && LastNameTH['cd:PersonLastNameTH'] || '');

      return LastName || FullLastNameTH;
    },
    Sequence(){

      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      
      const Sequence =
        r.CommitteeInformations &&
        r.CommitteeInformations[0] &&
        r.CommitteeInformations[0].Sequence;
      
      const juristicPersonList = r['cd:OrganizationJuristicPersonList'];

      const PersonSequence =
        juristicPersonList &&
        juristicPersonList[0] &&
        juristicPersonList[0]['td:JuristicPersonSequence'];

      return Sequence || PersonSequence;

    },
    Type(){

      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};
      
      const Type =
        r.CommitteeInformations &&
        r.CommitteeInformations[0] &&
        r.CommitteeInformations[0].Type;
      
      const juristicPersonList = r['cd:OrganizationJuristicPersonList'];

      const PersonType =
        juristicPersonList &&
        juristicPersonList[0] &&
        juristicPersonList[0]['td:JuristicPersonType'];

      return Type || PersonType;

    },
    AddressName(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const AddressName =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].AddressName;


      return AddressName || r['cd:OrganizationJuristicBranchName'] || '-';
    },
    FullAddress(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const FullAddress =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].FullAddress;

      const Address =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Address'];


      return FullAddress || Address || '-';
    },
    AddressNo(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const FullAddress =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].AddressNo;

      const Address =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:AddressNo'];


      return FullAddress || Address || '-';

    },
    Ampur(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Ampur =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Ampur;

      const City =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:City']&&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:City']['cr:CityTextTH'];
 
      return Ampur || City || '-';
    },
    Tumbol(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Tumbol =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Tumbol;

      const SubDivision =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:CitySubDivision']&&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:CitySubDivision']['cr:CitySubDivisionTextTH'];
 
      return Tumbol || SubDivision || '-';

    },
    Road(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Road =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Road;

      const RoadTH =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Road'];
 
      return Road || RoadTH || '-';

    },
    Road(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Road =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Road;

      const RoadTH =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Road'];
 
      return Road || RoadTH || '-';

    },
    Soi(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Soi =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Soi;

      const SoiTH =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Soi'];
 
      return Soi || SoiTH || '-';

    },
    Province(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Province =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Province;

      const CountrySubDivision =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:CountrySubDivision'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:CountrySubDivision']['cr:CountrySubDivisionTextTH'];
 
      return Province || CountrySubDivision || '-';

    },
    VillageName(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const VillageName =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].VillageName;

      const Village =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Village'];
 
      return VillageName || Village || '-';
    },
    Email(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Email =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Email;
 
      return Email || '-';
    },
    Phone(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Phone =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Phone;
 
      return Phone || '-';
    },
    Building(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Building =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Building;

      const BuildingTH =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Building'];
 
      return Building || BuildingTH || '-';
    },
    Floor(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Floor =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Floor;

      const FloorTH =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Floor'];
 
      return Floor || FloorTH || '-';
    },
    Moo(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Moo =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Moo;

      const MooTH =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:Moo'];
 
      return Moo || MooTH || '-';
    },
    RoomNo(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const RoomNo =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].RoomNo;

      const Room =
        r['cd:OrganizationJuristicAddress'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType'] &&
        r['cd:OrganizationJuristicAddress']['cr:AddressType']['cd:RoomNo'];
 
      return RoomNo || Room || '-';
    },
    AddressSequence(){
      const r = this.data
        && this.data.dbdinfo
        && this.data.dbdinfo.ResultList
        && this.data.dbdinfo.ResultList[0]
        ? this.data.dbdinfo.ResultList[0]
        : {};

      const Sequence =
        r.AddressInformations &&
        r.AddressInformations[0] &&
        r.AddressInformations[0].Sequence;

 
      return Sequence || '-';
    },
    AccountReceivable(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicAccountReceivable'] || '-';
    },
    NetProfit(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicNetProfit'] || '-';
    },
    TotalAsset(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicTotalAsset'] || '-';
    },
    TotalCurrentAsset(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicTotalCurrentAsset'] || '-';
    },
    StatementYear(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicStatementYear'] || '-';
    },
    TotalLiabilities(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicTotalLiabilities'] || '-';
    },
    TotalRevenue(){
      const r = this.financial
        && this.financial.data
        ? this.financial.data
        : {};
        
      return r['td:JuristicTotalRevenue'] || '-';
    },
  },
  async mounted() {
    this.data = this.inputEdit
    this.isEdit = this.isEdit
    // if (this.inputEdit.verification == 'เกษตรกร') {
    //   this.doaeData = await api.checkdoae(this.inputEdit.id_card)
    //   console.log(this.doaeData)
    // }
    if (this.juristicId && this.year) {
      let res = await api.getfinancial({ juristicId: this.juristicId, year: this.year })
      if (res && res.data && !res.data.status) {
        this.year = this.year - 1
        res = await api.getfinancial({ juristicId: this.juristicId, year: this.year })
      }
      
      
      this.financial = res.data
      let res2 = await api.getshareholder({ juristicId: this.juristicId })
      
      this.shareholder = res2.data.data
    }
  },
  methods: {
    isExist(item) {
      if (item) return item
      else return '-'
    },
    numberWithCommas(x) {
      x = x ? x.toString() : ''
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },
    async editData(payload) {
      payload.olddptype = this.inputEdit.dptype
      try {
        await this.$store.dispatch('depamemberinfo', payload)
        this.$emit('saveedit', payload)
      } catch (error) {}
    },
  },
}
</script>

<style lang="scss">
.greytext {
  color: rgb(173, 173, 173);
}
.uploaddepa {
  padding-right: 30px !important;
}
.dbdlabel {
  font-size: 12px;
  font-weight: 600;
  color: #97a4b7;
}
.dbdinfo {
  font-size: 13px;
  color: #013760;
}
</style>



// WEBPACK FOOTER //
// src/components/view/memberInfo/MemberInfoEdit.vue